import * as React from "react";

const Error: React.SFC<{}> = props => <div>Error</div>;

export default Error;
